import { Component, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { BusquedaFiltros } from '../../_models/busqueda-filtros';
import { Table } from 'primeng/table';
import { CalendarioPropiedades } from '../../_models/calendario-propiedades';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfiguracionUrlExternaService } from '../../_services/configuracion-url-externa.service';
import { ConfiguracionUrlExterna } from '../../_models/configuracion-url-externa';
import { Router } from '@angular/router';
import { config } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

@Component( {
  selector: 'app-extensiones-telefonicas-listado',
  templateUrl: 'extensiones-telefonicas-listado.component.html'
} )

export class ExtensionesTelefonicasListadoComponent implements OnInit {

  @ViewChild('dt') tabla: Table;

  public cargaInicial:boolean = true;
  public errorConfiguracion = false;

  //Variables del datatable
  public numRegistros:number;
  public buscando: boolean;
  public columnas: any[] = [];
  public listaConfiguracionesUrl: ConfiguracionUrlExterna[] = [];

  //Buscador
  public busqueda:string;

  //Paginacion
  page = '0';
  rowsPerPage = 10;
  rowsCount = 10;

  constructor(private navService:NavService,
              private fb:FormBuilder,
              private confUrlExternaService:ConfiguracionUrlExternaService,
              private router:Router,
              private confirmService:ConfirmationService){
    this.getRecords();
  }

  ngOnInit(): void {
    this.inicializarTabla();
  }

  private inicializarTabla(){

    this.columnas = [
      { field: 'codigo', header: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.LBL_NOMBRE' ), sort: false },
      { field: 'link', header: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.LBL_LINK' ), sort: false },
      { field: 'descripcion', header: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.LBL_DESCRIPCION' ), sort: false },
      { field: 'sistema', header: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.LBL_SISTEMA' ), sort: false },
      { field: 'acciones', header: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.LBL_ACCIONES' ), sort: false },
    ];
  }

  private getRecords(){
    this.confUrlExternaService.listadoHabilitados().subscribe( lstConfigUrl => {
      this.listaConfiguracionesUrl = lstConfigUrl;
    });
  }

  public verRespuesta(row){
    console.log(row);
  }

  public agregarNueva(){
    this.router.navigate(['apl/extensiones-telefonicas/agregar']);
  }

  public setBusqueda() {
    this.navService.setSearch( 'extensiones-telefonicas.component', this.busqueda );
  }

  public inhabilitarConfiguracion(configUrl:ConfiguracionUrlExterna){
    this.confirmService.confirm( {
      message: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_CONFIRMACIONINHABILITAR' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        const configInhabilitar = {
          idConfiguracionUrlExterna: configUrl.idConfiguracionUrlExterna,
          codigo: configUrl.codigo,
          nombre: configUrl.nombre,
          link: configUrl.link,
          descripcion: configUrl.descripcion,
          idSistema: configUrl.idSistema,
          sistema: configUrl.sistema,
          auditoriaFecha: configUrl.auditoriaFecha,
          auditoriaUsuario: configUrl.auditoriaUsuario,
          indicadorHabilitado: false
        } as ConfiguracionUrlExterna;

        this.confUrlExternaService.actualizar(configInhabilitar).subscribe( r => {
          configUrl.indicadorHabilitado = false;
          this.navService.setMesage( 0,
            {
              severity: 'success',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'EXTENSIONESTELEFONICAS.MSG_CONFIGURLELIMINADA' )
            } );
        });
      },
      reject: () => {
      }
    } );
  }

  public editarCofiguracion(configUrl:ConfiguracionUrlExterna){
    this.router.navigate(['apl/extensiones-telefonicas/actualizar/', configUrl.idConfiguracionUrlExterna]);
  }
}
